import templateUrl from './modelPickerModal.html';

export default angular.module('eventix.common.directives.modelPicker.modal', [])
    .component('modelPickerModal', {
        controller: ModelPickerModalController,
        templateUrl: templateUrl,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    }).name;

function ModelPickerModalController($scope, $state, $http, $q, $filter, ErrorRejector, UIMessages, Company, User, Role, Event, Ticket, Product, Shop) {
    const $ctrl = this;

    $ctrl.isAdminOrWLAdmin = Role.isAuthorizedAs('Admin') || Role.isAuthorizedAs('Whitelabel Admin');
    $ctrl.currentPage = 'Event';
    $ctrl.currentEvent = null;
    $ctrl.currentItems = [];
    $ctrl.searchTerm = {Event: '', Ticket: '', Product: '', Shop: ''};
    $ctrl.selected = {Event: [], Ticket: [], Product: [], Shop: []};
    $ctrl.eventUpcoming = true;
    $ctrl.overrideCompanyAlias = '';

    $ctrl.pick = pick;
    $ctrl.cancel = cancel;
    $ctrl.loader = loadItems;
    $ctrl.clickItem = clickItem;
    $ctrl.selectItems = selectItems;
    $ctrl.changePage = changePage;
    $ctrl.deselectAll = deselectAll;

    $ctrl.search = _.debounce(refreshTableView, 500, {leading: true, trailing: true});

    deselectAll();

    $ctrl.$onInit = function() {
        _.assign($ctrl, _.omit($ctrl.resolve, 'event'));

        let companyId = _.get($state.params, 'as');

        if (!companyId || !_.has(Company.cached, companyId))
            companyId = 'me';

        $ctrl.currency = _.get(Company.cached, [companyId, 'currency'], 'EUR');

        if ($ctrl.resolve.event)
            $ctrl.event = $ctrl.resolve.event;

        if (!$ctrl.outputModel)
            throw Error('Output model is required for this component to work');

        if ($ctrl.event) {
            $ctrl.currentEvent = $ctrl.event;
            $ctrl.currentPage = $ctrl.outputModel;
        }

        _.forEach($ctrl.selected, (selected, model) => {
            _.set($ctrl.selected, model, _.concat(selected, _.get($ctrl, _.lowerCase(model + 's'), [])));
        });

        refreshTableView();
    };

    $scope.$watch('$ctrl.eventUpcoming', function(value, old) {
        if (value === old) return;

        refreshTableView();
    });

    $scope.$watch('$ctrl.overrideCompanyAlias', function(value, old) {
        if (value === old) return;

        if (!$ctrl.lockEvent)
            changePage('Event');
    });

    function pick() {
        if ($ctrl.busy) return;

        let returnValues = {outputModel: $ctrl.outputModel};

        _.forEach($ctrl.selected, (selected, model) => {
            if ($ctrl.multiple) _.set(returnValues, _.lowerCase(model) + 's', selected);
            else _.set(returnValues, _.lowerCase(model), _.get($ctrl, _.lowerCase(model)));
        });

        if ($ctrl.lockEvent)
            _.set(returnValues, 'event', $ctrl.currentEvent);

        $ctrl.busy = false;

        $ctrl.close({$value: returnValues});
    }

    function cancel() {
        if ($ctrl.busy) return;

        $ctrl.busy = false;

        $ctrl.dismiss({});
    }

    function loadItems(offset, limit, sorting, filters) {
        $ctrl.busy = true;

        let companyId = (_.isNil(_.get($state.params, 'as')) ? _.get(User.cached, 'me.company_id') : _.get($state.params, 'as'));

        if (!_.isEmpty($ctrl.overrideCompanyAlias))
            companyId = $ctrl.overrideCompanyAlias;

        if (!companyId) return ErrorRejector.handle('Cannot load items: Missing company id');

        let query = {
            offset: offset,
            limit: limit
        };

        if (!_.isEmpty($ctrl.searchTerm[$ctrl.currentPage])) _.set(query, 'filter_name', $ctrl.searchTerm[$ctrl.currentPage]);

        let url = '/event/';
        let selectedCounts = {};

        switch ($ctrl.currentPage) {
            case 'Ticket':
                url += `${$ctrl.currentEvent.guid}/ticket`;
                break;
            case 'Product':
                url += `${$ctrl.currentEvent.guid}/product`;
                break;
            case 'Shop':
                url += `${$ctrl.currentEvent.guid}/shops`;
                break;
            case 'Event':
            default:
                url += `${$ctrl.eventUpcoming ? 'upcoming' : 'past'}/${companyId}`;

                if ($ctrl.outputModel !== 'Event') {
                    _.forEach(_.get($ctrl.selected, $ctrl.outputModel, []), selectedItem => {
                        if (selectedItem.event_id) {
                            _.set(selectedCounts, selectedItem.event_id, _.get(selectedCounts, selectedItem.event_id, 0) + 1);
                        }
                    });
                }

                break;
        }

        return $http.get(url, {params: query}).then(response => {
            let data = response.data;

            // For page Event, if upcoming is empty, try past. Limit to first time (totalRows not set)
            if (_.isUndefined($ctrl.totalRows) && $ctrl.currentPage === 'Event' && $ctrl.eventUpcoming && !_.size(data.data)) $ctrl.eventUpcoming = false;

            $ctrl.totalRows = data.total;

            let items = _.map(data.data, function(item) {
                switch ($ctrl.currentPage) {
                    case 'Ticket':
                        item = Ticket.new(item);
                        break;
                    case 'Product':
                        item = Product.new(item);
                        break;
                    case 'Shop':
                        item = Shop.new(item);
                        break;
                    case 'Event':
                    default:
                        let eventDates = _.get(item, 'event_dates', []);

                        item = Event.new(item);

                        item.start = _.get(_.minBy(eventDates, 'start'), 'start');
                        item.end = _.get(_.maxBy(eventDates, 'end'), 'end');

                        item.selectedCount = _.get(selectedCounts, item.guid, 0);

                        break;
                }

                item.selected = _.findIndex($ctrl.selected[$ctrl.currentPage], {guid: item.guid}) >= 0;

                return item;
            });

            $ctrl.currentItems = items;

            $ctrl.busy = false;

            return items;
        }, ErrorRejector.handle);
    }

    function clickItem(item) {
        if ($ctrl.currentPage !== $ctrl.outputModel) {
            $ctrl.busy = true;

            if ($ctrl.currentPage === 'Event') $ctrl.currentEvent = item;

            return changePage($ctrl.outputModel);
        }

        item.selected = !item.selected;

        if (item.selected) {
            if ($ctrl.outputModel !== 'Event' && !_.isNil($ctrl.currentEvent)) {
                _.set(item, 'event_key', `${$ctrl.currentEvent.name} (${moment($ctrl.currentEvent.start).format('YYYY-MM-DD')})`);

                _.set(item, 'event_ids', _.union(_.get(item, 'event_ids', []), [$ctrl.currentEvent.guid]));
            }

            $ctrl.selected[$ctrl.currentPage].push(item);
        } else {
            _.remove($ctrl.selected[$ctrl.currentPage], {guid: item.guid});
        }

        if (!$ctrl.multiple && $ctrl.currentPage === $ctrl.outputModel) {
            _.set($ctrl, _.lowerCase($ctrl.outputModel), item);

            // Exit the picker, as we can only pick one item.
            pick();
        }

        return item;
    }

    function selectItems(items) {
        if ($ctrl.currentPage !== $ctrl.outputModel)
            return ErrorRejector.handle('Cannot select whole page when not selecting the outputmodel');

        if (!$ctrl.multiple)
            return ErrorRejector.handle('Cannot select whole page when not selecting multiple items');

        return _.map(items, item => clickItem(item));
    }

    function changePage(newPage) {
        if (newPage === 'Event') {
            $ctrl.currentEvent = null;

            if ($ctrl.lockEvent)
                deselectAll();
        }

        $ctrl.currentPage = newPage;

        refreshTableView();
    }

    function deselectAll() {
        $ctrl.selected = {
            Event: [],
            Ticket: [],
            Product: [],
            Shop: [],
        };

        _.forEach($ctrl.currentItems, item => {item.selected = false;});
    }

    function refreshTableView() {
        $scope.$broadcast('table-view-refresh');
    }
}
